import React, {useEffect} from 'react';
import {Layout, TabsContainer} from '../components';
import LogsPage from './LogsPage';
import CheckinsPage from './CheckinsPage';
import {useDispatch} from 'react-redux';
import {
  getBuildings,
  getCustomers,
  getElevators,
} from '../actions';
import AllPaymentsPage from './AllPaymentsPage';
import OverviewPayments from './OverviewPayments';
import PendingPayments from './PendingPayments';
import GarageReportPage from './GarageReportPage';
import { getAllElevators } from '../actions/elevatorsActions';
import { getAllBuildings } from '../actions/buildingsActions';

const HEADERS = [
  'Logs',
  'Check ins',
  'Payments',
  'Pending Payments',
  'Overview Payments',
  'Garages',
];
const LogsTab = <LogsPage />;
const CheckInTab = <CheckinsPage />;
const PaymentsTab = <AllPaymentsPage />;
const OverviewPaymentsTab = <OverviewPayments />;
const PendingPaymentsTab = <PendingPayments />;
const GaragesTab = <GarageReportPage />;

const TAB_CONTENTS = [
  LogsTab,
  CheckInTab,
  PaymentsTab,
  PendingPaymentsTab,
  OverviewPaymentsTab,
  GaragesTab,
];

const Reports = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getElevators());
    dispatch(getAllElevators());
    dispatch(getCustomers());
    dispatch(getBuildings());
    dispatch(getAllBuildings());
  }, []);

  return (
    <Layout>
      <TabsContainer tabHeaders={HEADERS} tabContents={TAB_CONTENTS} />
    </Layout>
  );
};

export default Reports;
